import Reveal, { Eyebrow } from "./Reveal";
import { Check, X } from "lucide-react";

const ROLES = [
  { role: "Super Admin", can: "Agent catalog authoring and publishing; tenant creation; Tenant Admin creation.", cannot: "Cannot see tenant customer data." },
  { role: "Tenant Admin", can: "Campaigns; agent adoption; users; leads; settings including provider credentials; exports.", cannot: "Cannot edit prompts or the catalog." },
  { role: "Team Leader", can: "Allocates cases to own team's callers; time-bound settlement approvals.", cannot: "Own team only." },
  { role: "Caller", can: "Own allocated cases only; own disposition updates, audited.", cannot: "Nothing else. No other team's cases." },
];

const AdminRoles = () => (
  <section data-testid="admin-roles-section" className="py-20 sm:py-28 bg-white border-b border-zinc-200">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow>Admin & roles</Eyebrow>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
          Four logins. Each sees only its own work.
        </h2>
        <p className="text-zinc-600 mt-6 leading-relaxed">
          Run it without calling us: invite callers, organise teams and manage roles from the Users
          page. The Tenant Admin sets its own voice-provider key — platform values are fallback
          only. Catalog versions are adopted into your tenant as a copy, never a push.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-14">
        {ROLES.map((r, i) => (
          <Reveal key={r.role} delay={i * 0.07}>
            <div
              data-testid={`role-card-${i + 1}`}
              className="h-full bg-[#FAF9F6] border border-zinc-200 rounded-2xl p-7 hover:border-[#09090B] transition-colors duration-500"
            >
              <div className="flex items-center justify-between">
                <h3 className="font-display font-bold text-xl">{r.role}</h3>
                <span className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-400">Role 0{i + 1}</span>
              </div>
              <div className="mt-5 space-y-3.5">
                <p className="flex gap-3 text-sm text-zinc-700 leading-relaxed">
                  <Check size={16} className="text-[#16A34A] shrink-0 mt-0.5" />
                  {r.can}
                </p>
                <p className="flex gap-3 text-sm text-zinc-500 leading-relaxed">
                  <X size={16} className="text-[#D97706] shrink-0 mt-0.5" />
                  {r.cannot}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-8">
        <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-zinc-600">
          <span><span className="font-medium text-zinc-900">Cost rollup</span> — per-tenant cost view for Tenant Admins.</span>
          <span><span className="font-medium text-zinc-900">Human queue</span> — escalations flagged for people; settlement approvals time-bound and audited.</span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default AdminRoles;
